import Swiper from 'swiper'
import {
  Navigation,
  Pagination,
  EffectCards,
  EffectCoverflow,
} from 'swiper/modules'

function imageSlider() {
  const imageSliders = document.querySelectorAll('.image-slider')

  if (imageSliders.length > 0) {
    // Starting point
    imageSliders.forEach((imageSlider) => {
      function initializeSwiper() {
        // Counting the number of slides
        const slidesCount = imageSlider.querySelectorAll('.swiper-slide').length

        let swiper

        swiper = new Swiper(imageSlider, {
          modules: [Navigation, Pagination, EffectCards, EffectCoverflow],
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.image-swiper-pagination',
            type: 'custom',
            renderCustom: function (swiper, current, total) {
              return `<span class="text-red">${current}</span> / ${total}`
            },
          },
          loop: true,
          // loopAdditionalSlides: 4,
          initialSlide: 0,
          effect: 'coverflow',
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 'auto',
          autoplay: {
            delay: 2500,
          },
          coverflowEffect: {
            rotate: 0,
            slideShadows: false,
            stretch: 50, // This is the amount of overlap between slides
            depth: 30, // This is the amount of the 3D effect
            modifier: 8, // Controls the intensity of the 3D effect
          },
          spaceBetween: 10,
          breakpoints: {
            340: {
              // xs
              coverflowEffect: {
                depth: 30,
                modifier: 6.32,
              },
            },
            420: {
              // xs - sm
              coverflowEffect: {
                depth: 10,
                modifier: 10.32,
              },
            },
            576: {
              // sm
              coverflowEffect: {
                depth: 30,
                modifier: 4.87,
              },
            },
            768: {
              // md
              coverflowEffect: {
                depth: 25,
                modifier: 6.58,
              },
            },
            992: {
              // lg
              coverflowEffect: {
                depth: 20,
                modifier: 8.96,
              },
            },
            1280: {
              // xl
              coverflowEffect: {
                depth: 15,
                modifier: 11.9,
              },
            },
            1536: {
              // 2xl
              coverflowEffect: {
                depth: 10,
                modifier: 14.87,
              },
            },
          },
        })
      }

      // Initialize Swiper when the function is called
      initializeSwiper()

      // Also re-initialize when the window is resized
      window.addEventListener('resize', initializeSwiper)
    })
  }
}

export default imageSlider
